import React, { FunctionComponent } from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { moderateScale, scale } from 'react-native-size-matters';
import FeatherIcon from 'react-native-vector-icons/Feather';
import { Icon } from '../../../components';
import Theme from '../../../theme';

interface IVideoProps {
  localVideoIsMuted: boolean;
  onPress(): void;
}

export const VideoToggleButton: FunctionComponent<IVideoProps> = ({ onPress, localVideoIsMuted }) => (
  <TouchableOpacity onPress={onPress} style={[styles.control, { borderColor: Theme.PRIMARY }]}>
    <FeatherIcon
      size={moderateScale(23, 0.8)}
      color={Theme.PRIMARY}
      name={localVideoIsMuted ? 'video-off' : 'video'}
    />
  </TouchableOpacity>
);

interface IMicProps {
  buttonColor?: string;
  talkingEnabled: boolean;
  localAudioIsMuted: boolean;
  onPress(): void;
}

export const MicToggleButton: FunctionComponent<IMicProps> = ({
  onPress,
  localAudioIsMuted,
  talkingEnabled,
  buttonColor =  talkingEnabled ? Theme.PRIMARY : Theme.GREY_LIGHT}) => (
  <TouchableOpacity
    disabled={!talkingEnabled}
    onPress={onPress}
    style={[styles.control, {
      borderColor: buttonColor,
    }]}>
    <Icon
      size={moderateScale(25, 0.8)}
      color={buttonColor}
      name={(localAudioIsMuted || !talkingEnabled) ? 'md-mic-off' : 'md-mic'}
    />
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  control: {
    width: moderateScale(45, 0.8),
    height: moderateScale(45, 0.8),
    borderWidth: scale(1),
    borderRadius: scale(45) / 2,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
